var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-upload',{staticClass:"avatar-uploader",attrs:{"action":_vm.url,"show-file-list":false,"on-success":_vm.uploadSuccess,"headers":{
    Authorization: `bearer ${_vm.accessToken}`,
  },"data":{
  },"before-upload":_vm.beforeUpload}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }